// src/App.js
import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { QuoteProvider } from './context/QuoteContext';
import UserInterface from './interfaces/user/UserInterface';
import ManagerInterface from './interfaces/manager/ManagerInterface';
import Layout from './components/common/Layout';
import Login from './components/Login';

// Wrapper component that uses the auth context
const AppContent = () => {
  const { currentUser, loading, hasRole, isAdmin } = useAuth(); // Import hasRole and isAdmin
    
  // For debugging
  console.log("Current user:", currentUser);
  // Show loading indicator while checking auth
  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }
  
  // If not logged in, show login page
  if (!currentUser) {
    return <Login />;
  }
  
  return (
    <QuoteProvider>
      <Layout currentRole={currentUser.role}>
        {/* Update this line to include admin role */}
        {(hasRole('manager') || isAdmin()) ? 
          <ManagerInterface /> : 
          <UserInterface />}
      </Layout>
    </QuoteProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;